import { Header, Sidebar } from 'components/Global';
import { FORMDATA } from 'constants/Data';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { checkPermission } from 'utils/utils';
import styles from './index.module.scss';

const GlobalLayout = () => {

	const { pageMenuItems } = FORMDATA;
	const [finalMenuItems, setMenuItems] = useState<any>(pageMenuItems);
	const [isLoading] = useState(false);
	const { pathname } = useLocation();
	const [isLoggedIn, setIsLoggedIn] = useState(false);
	const navigate = useNavigate();

	const fetchedUserPermission = useSelector(
		(state: any) => state?.userProfile?.data?.permissions
	);
	const [selectedSidebar, setSelectedSidebar] = useState<string>('dashboard');

	const isDashboardPermission = checkPermission(fetchedUserPermission, {
		permissionName: 'Dashboard',
		permission: ['view'],
	});

	const isDevicePermission = checkPermission(fetchedUserPermission, {
		permissionName: 'Device',
		permission: ['view'],
	});

	const isSubscriptionPermission = checkPermission(fetchedUserPermission, {
		permissionName: 'Subscription',   //FIXME - change spelling from backend
		permission: ['add'],
	});
	useEffect(() => {
		if (!Array.isArray(pageMenuItems)) return;

		let updatedMenuItems = [...pageMenuItems]; // Copy array
		if (!isDashboardPermission) {
			updatedMenuItems = updatedMenuItems.filter((item) => item?.key !== 'dashboard');
		}

		if (!isDevicePermission) {
			updatedMenuItems = updatedMenuItems.filter((item) => item?.key !== 'device');
		}

		if (!isSubscriptionPermission) {
			updatedMenuItems = updatedMenuItems.filter((item) => item?.key !== 'subscription');
		}

		setMenuItems((prev: any) => {
			if (JSON.stringify(prev) !== JSON.stringify(updatedMenuItems)) {
				return updatedMenuItems;
			}
			return prev;
		});
	}, [isDashboardPermission, isDevicePermission, pageMenuItems, isSubscriptionPermission]);

	const handleSidebar = (sidebarProps: any) => {
		if (sidebarProps?.key === 'device') {
			setSelectedSidebar('device');
			navigate(`/`);
		} else {
			setSelectedSidebar(sidebarProps?.key);
			navigate(`/${sidebarProps?.key}`);
		}
	};

	const initialFunctionCall = () => {
		const pathKey = pathname.split('/')[1];
		const isValidKey = finalMenuItems.some((item: any) => item.key === pathKey);

		setSelectedSidebar(isValidKey ? pathKey : 'device');
	};


	useEffect(() => {
		initialFunctionCall();
	}, [pathname, finalMenuItems]);


	useEffect(() => {
		const token = localStorage.getItem('accessToken');

		if (token) {
			setIsLoggedIn(true);
		} else {
			setIsLoggedIn(false);
			navigate('/login');
		}
	}, []);

	// JSX
	return !isLoading ? (
		isLoggedIn ? (
			<div className={styles['global-layout']}>
				<div className={styles['global-layout__wrapper']}>
					<div className={styles['global-layout__header']}>
						<div className={styles['global-layout__body']}>
							<div className={styles['global-layout__body--sidebar']}>
								<Sidebar
									key={finalMenuItems?.length}
									items={finalMenuItems}
									selectedSidebar={selectedSidebar}
									handleSidebar={handleSidebar}
								/>
							</div>
							<div className={styles['global-layout__body--body']}>
								<Header />
								<Outlet />
							</div>
						</div>
					</div>
				</div>
			</div>
		) : null
	) : null;
};

export default GlobalLayout;
